import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

export function useIsDataRetentionEnabled() {
	const { formatMessage } = useIntl();

	const getRetentionDeleteButtonText = () => {
		if (fg('block-delete-jira')) {
			return formatMessage(messages.deleteDataRetention);
		}

		return null;
	};

	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	const getRetentionDeleteHeading = ((formatted?: boolean) => {
		if (fg('block-delete-jira')) {
			return formatted
				? formatMessage(messages.deleteHeadingDataRetention)
				: messages.deleteHeadingDataRetention;
		}

		return null;
	}) as {
		(formatted: true): string | null;
		(formatted?: false): { id: string; defaultMessage: string; description: string } | null;
	};

	const getRetentionDeleteWarning = (workType?: string) => {
		if (fg('block-delete-jira')) {
			return formatMessage(messages.deleteWarningDataRetention, {
				workType: workType?.toLowerCase(),
			});
		}

		return null;
	};

	return {
		getRetentionDeleteButtonText,
		getRetentionDeleteHeading,
		getRetentionDeleteWarning,
	};
}
